import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'label-title',
    template: `<div class="label-section" fxLayout="column">
                  <div class="label-title">{{title}}</div>
                  <div class="label-content"><ng-content fxFlex></ng-content></div>
               </div>`,
    styleUrls: ['labelTitle.css']
})
export class LabelTitleComponent implements OnInit {
    @Input()
    title: string;
    @Input()
    value: string;
    constructor() { }

    ngOnInit(): void { }
}
